import { ButtonGroup, Flex, FormControl, SimpleGrid } from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../../../components/card/Card";
import CustomButton from "../../../components/Common/CustomButton";
import IsLoading from "../../../components/Common/IsLoading";
import Items from "./items";
import {
  selectButtonLoading,
  selectFormData,
  selectLoading,
  selectStateList,
} from "./redux/selector";
import { actions } from "./redux/slice";
import ReactMultiSelect from "../../../components/Common/CustomInput/ReactMultiSelect";
import { useTranslation } from "react-i18next";

const Create = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(selectFormData);
  const loader = useSelector(selectLoading);
  const loading = useSelector(selectButtonLoading);
  const stateList = useSelector(selectStateList);

  React.useEffect(() => {
    dispatch(actions.doGetStateList());
    return () => {};
  }, []);

  React.useEffect(() => {
    if (params.id) {
      dispatch(actions.doGetById(params?.id));
    }
    return () => {};
  }, [params.id]);

  const handleMultiSelectChange = (name: string, selectedIds: string[]) => {
    dispatch(actions.updateFormValue({ key: name, value: selectedIds }));
  };

  const handleCancel = () => {
    dispatch(actions.clearFrom());
    navigate(-1);
  };

  const handleSubmit = () => {
    if (form?._id) {
      dispatch(
        actions.doUpdate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    } else {
      dispatch(
        actions.doCreate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    }
  };

  return (
    <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card>
        {loader ? (
          <IsLoading />
        ) : (
          <FormControl>
            <SimpleGrid columns={[1, 1, 2, 3]} spacingX={5}>
              <ReactMultiSelect
                name={"stateId"}
                selectedIds={form.stateId}
                onSelect={handleMultiSelectChange}
                title={t("shipping.form.selectState")}
                options={stateList}
              />
            </SimpleGrid>

            <Items />
            <SimpleGrid columns={1} spacing={10}>
              <Flex flexDirection="column">
                <ButtonGroup justifyContent={"flex-end"} mt={8}>
                  <CustomButton
                    handleClick={handleCancel}
                    title={t("common.button.cancel")}
                    loading={false}
                    variant="light"
                    sx={{ marginRight: "20px" }}
                  />
                  <CustomButton
                    handleClick={handleSubmit}
                    title={t("common.button.save")}
                    loading={loading}
                    disabled={!form?.stateId}
                    sx={{ marginLeft: "20px" }}
                  />
                </ButtonGroup>
              </Flex>
            </SimpleGrid>
          </FormControl>
        )}
      </Card>
    </Flex>
  );
};

export default Create;
